import defaultTheme from './default';
import type { IMailSubscriptionTheme } from './types/IMailSubscriptionTheme';

export const MailSubscriptionTheme: IMailSubscriptionTheme = {
  ...defaultTheme,

  defaultPrimaryColor: 'var(--primary-color, #095f9a)',
  defaultDarkColor: 'var(--dark, #333333 )',
};
